module.exports = __webpack_public_path__ + "img/eye-young-complete-4-skin-fibres.34434188.jpg";